import { makeStyles } from '@material-ui/core';
const useStyles = makeStyles((theme: any) => {
  return {
    container: {
      color: theme.custom.colors.midBlack,
    },
    titleModal: {
      font: theme.custom.font.heading6,
      marginBottom: 10,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      paddingRight: 10
    },
    subtitleModal: {
      font: theme.custom.font.montserrat16,
    },
    paperModal: {
      margin: '0 auto',
      maxWidth: 1030,
      color: theme.custom.colors.primary
    },
    tableHeadPadding: {
      paddingRight: 30,
    },
    contentModal: {
      padding: '15px 25px',
      maxHeight: '659px',
      maxWidth: 1029,
    },
    maxWidthEmail: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      maxWidth: 300,
      display: 'inline-block',
    },
    contentModalBrik: {
      padding: '10px 25px 0',
      maxHeight: '602px',
      maxWidth: 1029,
      height: 'calc(100vh - 70px)',
      display: 'flex',
      flexDirection: 'column',
    },
    contentBodyModalBrikEmpty: {
      display: 'flex',
      flex: 1,
      alignItems: 'center',
      padding: '0 30px',
      marginBottom: 50,
      '&.d-top': {
        justifyContent: 'flex-start',
        marginBottom: 0,
        minHeight: 450,
        flexDirection: 'column',
        maxWidth: 500,
        margin: '0 auto',
      }
    },
    contentBodyModal: {
      display: 'flex',
      minHeight: '400px',
      alignItems: 'center',
      padding: '0 30px',
      marginBottom: 50,
      '&.d-top': {
        justifyContent: 'flex-start',
        marginBottom: 0,
        minHeight: 450,
        flexDirection: 'column',
        maxWidth: 500,
        margin: '0 auto',
      }
    },
    contentCenter: {
      display: 'flex',
      width: '100%'
    },
    boxUploadImages: {
      display: 'inline-flex',
      width: 156,
      height: 156,
      borderRadius: '50%',
      border: `4px dashed #D2D2D2`,
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      cursor: 'pointer',
      font: theme.custom.font.montserrat16Bold,
      color: '#7F7F7F',
    },
    label: {
      font: theme.custom.font.label,
    },
    marginBottom10: {
      marginBottom: 10,
    },
    labelInputGroupName: {
      marginBottom: 20,
    },
    labelInputGroupDescription: {
      '& textarea': {
        height: 100,
      }
    },
    contentLeft: {
      width: '55%',
      '& label': {
        fontFamily: 'Montserrat',
      }
    },
    contentRight: {
      width: '45%',
      paddingLeft: '10%',
      display: 'flex',
      flexDirection: 'column',
      '& label': {
        fontFamily: 'Montserrat',
        fontWeight: 400,
      },
      '& .uploadImage': {
        borderRadius: '50%',
        width: 156,
        height: 156,
        '& label': {
          textAlign: 'center',
          color: theme.custom.colors.placeholder,
          fontFamily: 'Public-sans',
          fontWeight: 700,
          fontSize: 16,
          whiteSpace: 'pre',
        }
      },
      '& img': {
        width: 156,
        height: 156,
        objectFit: 'cover',
        borderRadius: '50%',
      }
    },
    closeButton: {
      position: 'absolute',
      right: 24,
      top: 10,
      color: '#000000',
      width: 30,
      height: 30,
    },
    modalFooter: {
      boxShadow: `1px 1px 6px rgba(56, 25, 81, 0.25)`,
      textAlign: 'right',
      padding: 15,
      display: 'flex',
      justifyContent: 'flex-end',
      '&>span': {
        cursor: 'pointer',
        height: 32,
        display: 'flex',
        alignItems: 'center',
      },
      '& .d-inline-block': {
        display: 'inline-block',
      }
    },
    modalFooterBrik: {
      boxShadow: `1px 1px 6px rgba(56, 25, 81, 0.25)`,
      textAlign: 'right',
      padding: 15,
      marginLeft: -30,
      width: 'calc(100% + 55px)',
      '&>span': {
        cursor: 'pointer',
      },
      '& .d-inline-block': {
        display: 'inline-block',
      }
    },
    wrapItemBrik: {
      '& .brik-item-description': {
        marginBottom: 15,
      }
    },
    titleParagraph: {
      font: theme.custom.font.paragraph2,
      color: theme.custom.colors.primary,
      marginBottom: 20,
    },
    wrapFilter: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: 16,
    },
    title: {
      font: theme.custom.font.heading2,
      marginTop: 40,
      fontSize: '24px'
    },
     customerBanner: {
      marginTop: 35,
      marginBottom: 25,
      padding: '12px auto',
      // backgroundColor: '#F5F5F5',
      borderRadius: 8,
      font: '400 14px/20px "Montserrat"',
      color: '#4A4A4A',
    },
    customersCount: {
      font: theme.custom.font.paragraph,
      color: theme.custom.colors.primary,
      marginBottom: -13,
      fontWeight: 600,
    },
    wrapSearch: {
      display: 'flex',
      border: `1px solid ${theme.custom.colors.borderGrey}`,
      borderRadius: '30px',
      height: 32,
      width: 385,
      maxWidth: '100%',
      paddingLeft: 10,
      alignItems: 'center',
      '& span': {
        display: 'inline-block',
        cursor: 'pointer',
        width: 30,
        textAlign: 'center',
        paddingTop: 4,
      },
      '& input': {
        border: 'none',
        font: `400 12px/16px "Montserrat"`,
        height: 30,
        borderRadius: '30px',
        flex: 1,
        padding: '0 20px 0 5px',
        '&:focus': {
          outline: 'none'
        }
      }
    },
    btnCreateNew: {
      marginLeft: '20px',
      '& button': {
        height: 32,
        background: theme.custom.colors.midBlack,
        color: theme.custom.colors.white,
        fontSize: theme.custom.fontSize.size16,
        fontFamily: theme.custom.fontFamily.regular,
        fontWeight: '300',
        boxShadow: 'none',
        textTransform: 'inherit',
        borderRadius: '30px',
        '&:hover': {
          background: theme.custom.colors.primary,
        },
      },
    },
    boxRight: {
      display: 'flex',
    },
    cellHead: {
    },
    cellBody: {
      borderBottom: 'none !important',
      font: '400 16px/20px "Montserrat" !important',
      padding: '10px !important',
      paddingLeft: '30px !important',
    },
    wrapTable: {
      border: `1px solid ${theme.custom.colors.borderTable}`,
      borderRadius: 10,
      marginTop: 20,
      '& th': {
        font: theme.custom.font.heading3,
        color: theme.custom.colors.midBlack,
        borderBottom: 'none',
        padding: 15,
        paddingLeft: 30,
      }
    },
    tableBody: {
      borderTop: `1px solid ${theme.custom.colors.borderTable}`,
      height: '62vh',
      minHeight: 300,
      overflow: 'auto',
      paddingBottom: 25,
      '& tr': {
        cursor: 'pointer',
        '&:hover': {
          background: theme.custom.colors.iconHighLight
        }
      },
      '&::-webkit-scrollbar': {
        width: '20px !important',
      },
      '&::-webkit-scrollbar-thumb': {
        boxShadow: 'inset 0 0 10px 10px #C4C4C4',
        border: 'solid 8.5px white'
      }
    },
    afterBody: {
      display: 'block',
      height: 30,
    },
    dFlex: {
      display: 'flex',
      alignItems: 'center',
    },
    colorRed: {
      color: 'red',
    },
    avatar: {
      width: `30px !important`,
      height: `30px !important`,
      fontSize: '1rem',
      marginRight: 10,
      '& img': {
        width: 30,
        height: 30,
        objectFit: 'cover',
      }
    },
    headTypeAdd: {
      maxWidth: 500,
      width: '100%',
      marginTop: 50,
      position: 'relative',
      marginBottom: 5,
      borderBottom: `1px solid #000`,
      '& input': {
        boxShadow: 'none',
        border: 'none',
        // borderBottom: `1px solid #000`,
        font: theme.custom.font.paragraph,
        padding: '8px 10px',
        width: '90%',
        '&:focus': {
          outline: 'none'
        }
      }
    },
    btnAdd: {
      position: 'absolute',
      right: 0,
      top: 0,
      background: 'none',
      boxShadow: 'none',
      border: 'none',
      color: '#4A4A4A',
      font: `700 18px/22px "Montserrat-Bold"`,
      textTransform: 'uppercase',
      padding: 0,
      height: 30,
    },
    iconCloseAdd: {
      display: 'inline-flex',
      width: 24,
      height: 24,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      border: `2px solid ${theme.custom.colors.borderTable}`,
      position: 'absolute',
      top: 2,
      right: 2,
      cursor: 'pointer'
    },
    bodyTypeAdd: {
      overflow: 'auto',
      maxHeight: 370,
      width: '100%',
      padding: 5,
    },
    addItem: {
      position: 'relative',
      padding: '6px 10px',
      borderRadius: 20,
      marginBottom: 13,
      border: `1px solid #d2d2d2`,
      minWidth: 280,
      maxWidth: 'fit-content',
      font: theme.custom.font.paragraph,
      color: theme.custom.colors.placeholder,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      paddingRight: '30px'
    },
    headCustomerGroup: {
      marginBottom: 20,
      '& h2': {
        font: theme.custom.font.headingMontserrat1,
        color: theme.custom.colors.midBlack,
        marginBottom: 20,
        lineHeight: '30px',
      },
      '& h3': {
        font: theme.custom.font.heading3,
        color: theme.custom.colors.primary,
        marginBottom: 15,
      },
      '& p': {
        font: theme.custom.font.paragraph,
        marginBottom: 15,
      }
    },
    textLine:{
      flex: 1,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      display: '-webkit-box',
      '-webkit-line-clamp': '1',
      '-webkit-box-orient': 'vertical',
      height: 20,
    },
    pagination: {
      textAlign: 'center',
      margin: '20px auto',
      '& ul': {
        display: 'inline-flex',
      },
      '& li button': {
        font: `400 16px/20px "Roboto"`,
        '&.Mui-selected': {
          background: '#434343',
          color: '#fff'
        }
      }
    },
    
    dialogCustom: {
      '& button.Mui-focusVisible>span:last-child': {
        display: 'none',
      },
      '& h3': {
        fontSize: '18px',
      },
      '& .MuiDialog-paperWidthSm': {
        width: '561px',
        height: '160px',
      },
    },

    titleDialog: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '12px',
    },
    iconClose: {
      cursor: 'pointer',
    },
    contentDialog: {
      fontSize: '18px',
      lineHeight: '24px',
    },
    buttonBox: {
      padding: '10px 20px',
    },
    buttonDelete: {
      background: theme.custom.colors.primary,
      color: theme.custom.colors.white,
      padding: '8px 16px',
      borderRadius: '100px',
      '&:hover': {
        background: theme.custom.colors.primary,
      },
    },
    textRight: {
      textAlign: 'right',
    },
    fontLato: {
      font: theme.custom.font.montserrat14,
      color: theme.custom.colors.primary,
      lineHeight: '20px',
      marginBottom: 30,
    },
    btnAddBriks: {
      display: 'inline-flex',
      alignItems: 'center',
      font: theme.custom.font.h3,
      color: theme.custom.colors.midBlack,
      marginBottom: 20,
      cursor: 'pointer',
      '& img': {
        marginRight: 10,
      }
    },
    dFlexColum: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: '0 auto',
      '& img': {
        maxWidth: 240,
        marginBottom: 20,
      },
      '& p': {
        font: theme.custom.font.paragraph2,
        color: theme.custom.colors.primary,
        marginBottom: 20,
      }
    },
    mr0:{
      marginTop: '0 !important',
      marginBottom: '0 !important',
    },
    boxShadowHead: {
      boxShadow: `1px 1px 6px rgba(56, 25, 81, 0.25)`,
      marginTop: -20,
      marginLeft: -25,
      width: `calc(100% + 50px)`,
      padding: `20px 20px 15px`
    },
    contentBriksSugget: {
      margin: '0px auto 10px',
      overflow: 'auto',
      minHeight: 260,
      alignItems: 'flex-start',
      height: 520,
      padding: 0,
      overflowX: 'hidden',
      width: 'calc(100% + 20px)',
      paddingRight: 95,
      paddingLeft: 80,
    },
    wrapBorderTran: {
      '&>div': {
        border: `none`,
      },
      '& .brik-item-description': {
        marginBottom: 15,
      }
    },
    activeItem: {
      display: 'block',
      '&>div': {
        border: `1px solid ${theme.custom.colors.purp}`,
      }
    },
    resultBox: {
      boxShadow: "1px 1px 6px rgba(56, 25, 81, 0.25)",
      width: "100%",
      borderRadius: '6px',
      position: 'absolute',
      background: 'white',
      zIndex: 1,
      top: 'calc(100% + 5px)',
    },
    resultText: {
      font: `400 14px/18px "Montserrat"`,
      height: 32,
      display: 'flex',
      alignItems: 'center',
      paddingLeft: "28px",
      "&:hover": {
        background: "#F0F0F0",
        cursor: 'pointer',
      }
    },

    textBold: {
      font: `700 14px/18px "Montserrat"`,
    },
    textNormal: {
      font: `400 14px/18px "Montserrat"`,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
    textNoResult: {
      font: `400 14px/18px "Montserrat"`,
      margin: "12px 16px",
    },
    noData: {
      display: 'flex',
      alignItems: 'center',
      height: 260,
      justifyContent: 'center',
      padding: 20,
      font: `normal normal 400 14px/16px Montserrat`,
    },
    styleLoadingPage: {
      width: '100%',
      height: 'calc(100vh - 250px)',
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    inputEmail: {
      '&::placeholder': {
        color: '#333333'
      }
    },
    iconLoading: {
      marginLeft: '15px',
      '& svg': {
        color: '#fff',
      },
    },
    cancelledTooltip: {
      padding: '12px 16px',
      backgroundColor: theme.custom.colors.midBlack,
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
      borderRadius: 8,
      fontSize: 14,
      lineHeight: '20px',
      fontFamily: 'Montserrat',
      maxWidth: 280,
    },
    cancelledTooltipArrow: {
      color: theme.custom.colors.midBlack,
    },
  };
});

export default useStyles;
